
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog",
      function () {
        return require("private-next-pages/catalog.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog"])
      });
    }
  